import { makeApiCall, makeFormApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START GET DEAD MEMBER REPORT DETAILS  ******************** */
export const deadmemberDetailsListGet = (listData: any) => {
	const data = {
		GetDeadMemberReportToken: listData,
	};
	const url = `${API_URL}PostAllDeadMemberDetails`;
	return makeApiCall(url, data);
};
/** *********************  END GET DEAD MEMBER REPORT DETAILS  ******************** */

/** *********************  START GET DEAD MEMBER EXPORT REPORT DETAILS  ******************** */
export const deadmemberDetailsListExport = (listData: any) => {
	const params = new URLSearchParams();
	params.append('GetDeadMemberToken', listData);
	const url = `${API_URL}/Excel/DeadMemberReportExportWithToken.php`;

	return makeFormApiCall(url, params);
};
/** *********************  END GET DEAD MEMBER EXPORT REPORT DETAILS  ******************** */
